import { render, staticRenderFns } from "./lgdormitorio.vue?vue&type=template&id=5db3b962&"
import script from "./lgdormitorio.vue?vue&type=script&lang=js&"
export * from "./lgdormitorio.vue?vue&type=script&lang=js&"
import style0 from "./lgdormitorio.vue?vue&type=style&index=0&id=5db3b962&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports